let billingPeriod = 'yearly';
const tariffInfos = {
  starter: {
    seatsIncluded: 6,
    pricePerSeat: 10,
    basePrice: {
      monthly: 49,
      yearly: 45,
    },
  },
  small: {
    seatsIncluded: 15,
    pricePerSeat: 8,
    basePrice: {
      monthly: 99,
      yearly: 89,
    },
  },
  business: {
    seatsIncluded: 40,
    pricePerSeat: 6,
    basePrice: {
      monthly: 199,
      yearly: 179,
    },
  },
  corporate: {
    seatsIncluded: 220,
    pricePerSeat: 4,
    basePrice: {
      monthly: 799,
      yearly: 719,
    },
  },
};
function toggleBillingPeriod(newBillingPeriod) {
  billingPeriod = newBillingPeriod;
  fillTariffInfos();
  document.querySelectorAll('.tariffTable__billingPeriodToggleButton').forEach((el) => {
    el.dataset.active = el.dataset.billingperiod === billingPeriod ? 'true' : 'false';
  });
}
function getTariffInfos(tariff, infoProp) {
  return infoProp === 'basePrice'
    ? tariffInfos[tariff]?.[infoProp]?.[billingPeriod]
    : tariffInfos[tariff]?.[infoProp];
}

function fillTariffInfos() {
  document.querySelectorAll('.tariffCard__basePriceCrossed').forEach((el) => {
    el.textContent = `${tariffInfos[el.dataset.tariff]?.basePrice?.monthly} €`;
    billingPeriod === 'monthly' ? (el.hidden = true) : (el.hidden = false);
    let child = document.createElement('div');
    child.classList.add('tariffCard__priceCross');
    el.appendChild(child);
  });
  document.querySelectorAll('.tariffCard__basePrice').forEach((el) => {
    el.textContent = `${getTariffInfos(el.dataset.tariff, 'basePrice')} €`;
  });

  document.querySelectorAll('.tariffCard__pricePerSeat').forEach((el) => {
    el.textContent = `${getTariffInfos(el.dataset.tariff, 'pricePerSeat')} € pro zusätzlichem Mitarbeitenden`;
  });

  document.querySelectorAll('.tariffCard__seatsIncluded').forEach((el) => {
    el.textContent = `${getTariffInfos(el.dataset.tariff, 'seatsIncluded')} Mitarbeitende inkl.`;
  });

  document.querySelectorAll('.tariffCard__button').forEach((el) => {
    el.setAttribute('href', el.dataset.baselink + el.dataset.tariff + `/${billingPeriod}`);
  });
}
window.addEventListener('DOMContentLoaded', function () {
  toggleBillingPeriod('yearly');
});

document.querySelectorAll('.tariffTable__billingPeriodToggleButton').forEach((el) => {
  el.onclick = (e) => {
    toggleBillingPeriod(e.target.dataset.billingperiod);
  };
});
